import { fetchUserInfo } from './api.js';

/** 微信小程序名称（搜索用） */
export const MINIPROGRAM_NAME = 'gpx merge';

export function normalizeUserInfo(data) {
    let user = data?.userInfo ?? data?.user_info ?? data;
    if (user?.userInfo) {
        user = user.userInfo;
    }
    if (user?.user_info) {
        user = user.user_info;
    }
    return user;
}

export async function refreshUserInfo(email) {
    const res = await fetchUserInfo(email);
    return normalizeUserInfo(res.data);
}
